import { Injectable } from "@angular/core";
import { createStore } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { FileTranslation } from "./file-translation.model";
import { localStorageStrategy, persistState } from "@ngneat/elf-persist-state";
import { debounceTime } from "rxjs";

const fileTranslationsStore = createStore({ name: "file-translations" }, withEntities<FileTranslation>());

@Injectable({ providedIn: "root" })
export class FileTranslationsStore {
	constructor() {
		persistState(fileTranslationsStore, {
			storage: localStorageStrategy,
			source: () => fileTranslationsStore.pipe(debounceTime(1000)),
		});
	}

	public store = fileTranslationsStore;

	reset = () => {
		fileTranslationsStore.reset();
	};
}
